
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'message-report',

	props: {
		src: String,
		isWidget: {
			type: Boolean,
			default: false
		}
	}
});
